﻿/**
* Angular bootstrap entry point
* - same as main.ts but for AOT (Ahead of time) bundling
* AOT wil compile all templates and modules allowing angular to be faster at runtime
*/


import { enableProdMode } from '@angular/core';

//#region  specific aot config
//use platform-browser instead of platform-browser-dynamic
import { platformBrowser } from '@angular/platform-browser';
import { AppModuleNgFactory } from './app/app.module.ngfactory';

//#endregion

enableProdMode();
platformBrowser().bootstrapModuleFactory(AppModuleNgFactory);
